import React from 'react';
import { createFromIconfontCN } from './icon-font';
const CustomIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_3267196_q0aupqdgt8.js',
});
export const CnIcon = (props) => {
    const { type = '', ...otherProps } = props;
    let realType = type || '';
    if (!type.startsWith('icon-')) {
        realType = `icon-${type}`;
    }
    return React.createElement(CustomIcon, { type: realType, ...otherProps });
};
CnIcon.defaultProps = {
    size: 'medium',
};
CnIcon.displayName = 'CnIcon';
/**
 * @deprecated 建议直接从 cn-ui-m 中导出
 */
CnIcon.createFromIconfontCN = createFromIconfontCN;
